/* ==========================================================================
   Header
   ========================================================================== */

// ...

// Change nav bg once scrolled
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

gsap.to(".header", {
  scrollTrigger: {
    trigger: document.body,
    start: () => "top+=190px top",
    end: () => "bottom+=100% top",
    endTrigger: "html",
    scrub: true,
    toggleClass: {
      targets: ".header",
      className: "is-white",
    },
  },
});

// Show nav on menu toggle click

var checkBox = document.getElementById("menu-toggle") as HTMLInputElement;
var navContainer = document.getElementById("menu") as HTMLElement;

checkBox.addEventListener("click", toggleNav);

function toggleNav() {
  checkBox.classList.toggle("focus-visible"),
    navContainer.classList.toggle("block");
}

// Hide nav on scroll down, show on up
(function () {
  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  var header = document.getElementById("site-header");
  var mobileNavCheck = <HTMLInputElement>document.getElementById("menu-toggle");

  var checkScroll = function () {
    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) {
      direction = 2;
    } else if (curScroll < prevScroll) {
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  var toggleHeader = function (direction: number, curScroll: number) {
    if (mobileNavCheck.checked) {
      return;
    } else {
      if (direction === 2 && curScroll > 30 && header !== null) {
        header.classList.add("hide");
        prevDirection = direction;
      } else if (direction === 1 && header !== null) {
        header.classList.remove("hide");
        prevDirection = direction;
      }
    }
  };

  window.addEventListener("scroll", checkScroll);
})();
